<template lang="html">
  <section class="main">
    <!-- Mobile overlay -->
    <div 
      v-if="sidebarOpen" 
      class="mobile-overlay" 
      @click="sidebarOpen = false"
    ></div>
    
    <div class="sidepanel" :class="{ 'mobile-open': sidebarOpen }">
      <OffCanvas 
        @change-view="changeView" 
        :active-section="currentComponent"
      />
    </div>
    <div class="contents">
      <AdminNavbar 
        @change-view="changeView" 
        :active-section="currentComponent"
        :ticket-count="supportTicketBadge"
        @toggle-sidebar="toggleSidebar"
      />
      <div class="component-wrapper">
        <component :is="currentComponent" />
      </div>
    </div>
  </section>
</template>

<script>
import OffCanvas from '../../components/adminpage/side_bar.vue'
import ReviewManagement from '../../components/adminpage/ReviewManagement.vue'
import AdminNavbar from '../../components/adminpage/navbar.vue'
import OverView from '../../components/adminpage/overview.vue'
import SalesData from '../../components/adminpage/sales.vue'
import TeamMembers from '../../components/adminpage/teammembers.vue'
import ProDucts from '../../components/adminpage/products.vue'
import AdminCart from '../../components/adminpage/cart.vue'
import CustomerOrders from '../../components/adminpage/orders.vue'
import KidsStoreOrders from '../../components/adminpage/kids_orders.vue'
import UserRoleAssignment from '../../components/adminpage/usermgt.vue'
import CreateProduct from '../../components/adminpage/create_product.vue'
import CreateParalympicEquipment from '../../components/adminpage/create_paralympic_equipment.vue'
import CreateKidsProduct from '../../components/adminpage/create_kids_product.vue'
import AdminSupport from '../../components/adminpage/support.vue'
import AdminCalendar from '../../components/adminpage/Calender.vue'
import UserManagement from '../../components/adminpage/ListCustomer.vue'
import SellerManagement from '../../components/adminpage/ListSeller.vue'
import AdminPitchesView from '../../components/adminpage/PiitchManagement.vue'
import AdminProductListings from '../../components/adminpage/SellerListings.vue'
import AdminSellerReviews from '../../components/adminpage/SellerReviews.vue'
import AdminDiscountManager from '../../components/adminpage/Discount.vue'

export default {
  name: 'AdminMainPage',

  provide() {
    return {
      setSupportTicketPendingCount: (count) => {
        const n = Number(count);
        if (Number.isFinite(n) && n >= 0) {
          this.supportTicketBadge = n;
        }
      },
    };
  },

  components: {
    OffCanvas,
    AdminNavbar,
    UserManagement,
    OverView,
    AdminDiscountManager,
    SalesData,
    TeamMembers,
    ProDucts,
    SellerManagement,
    AdminCart,
    CustomerOrders,
    KidsStoreOrders,
    AdminPitchesView,
    UserRoleAssignment,
    CreateProduct,
    CreateParalympicEquipment,
    CreateKidsProduct,
    AdminSupport,
    AdminCalendar,
    ReviewManagement,
    AdminProductListings,
    AdminSellerReviews
  },

  data() {
    return {
      currentComponent: 'OverView',
      sidebarOpen: false,
      /** Pending customer support tickets (super_admin / support only); updated by AdminSupport */
      supportTicketBadge: 0,
    }
  },
  mounted() {
    // Handle window resize for responsive sidebar
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    changeView(viewName) {
      this.currentComponent = viewName;
      // Close sidebar on mobile after navigation
      if (window.innerWidth <= 768) {
        this.sidebarOpen = false;
      }
    },
    handleResize() {
      // Auto-close sidebar on resize to desktop
      if (window.innerWidth > 768) {
        this.sidebarOpen = false;
      }
    },
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
    }
  }
}
</script>

<style scoped>
.main {
  display: flex;
  width: 100%;
  background-color: var(--background-color1);
  height: 100vh;
  overflow: hidden;
  position: relative;
}

/* Sidebar stays fixed */
.sidepanel {
  position: fixed;
  top: 0;
  left: 0;
  width: 18%;
  min-width: 200px;
  height: 100vh;
  background-color: var(--background-color2);
  border-right: 2px solid rgba(47, 43, 43, 0.4);
  transition: width 0.3s ease, transform 0.3s ease;
  z-index: 1000;
  overflow-y: auto;
  overflow-x: hidden;
}

/* Content area occupies the remaining space */
.contents {
  margin-left: 18%;
  width: 82%;
  height: 100vh;
  max-height: 100vh;
  min-height: 0;
  display: flex;
  flex-direction: column;
  transition: margin-left 0.3s ease, width 0.3s ease;
  overflow: hidden;
  position: relative;
}

/* Navbar fixed to the top of the content area */
.contents > :first-child {
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  flex-shrink: 0;
  flex-grow: 0;
  height: auto;
  min-height: fit-content;
}

/* Component wrapper for scrolling */
.component-wrapper {
  flex: 1 1 0%;
  overflow-y: scroll !important;
  overflow-x: hidden;
  padding: 1rem;
  min-height: 0;
  max-height: 100%;
  -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
  position: relative;
  width: 100%;
  box-sizing: border-box;
}

/* Ensure all child components can scroll and don't constrain height */
.component-wrapper > * {
  min-height: fit-content;
  overflow: visible;
  max-width: 100%;
}

/* Sidebar hover border highlight */
.sidepanel:hover {
  border-right-color: var(--border-color-hover);
}

/* Tablet and smaller desktop (1024px and below) */
@media (max-width: 1024px) {
  .sidepanel {
    width: 200px;
    min-width: 200px;
  }
  
  .contents {
    margin-left: 200px;
    width: calc(100% - 200px);
  }
  
  .component-wrapper {
    padding: 0.75rem;
    overflow-y: scroll !important;
    max-height: 100%;
    min-height: 0;
  }
}

/* Medium tablets (900px and below) */
@media (max-width: 900px) {
  .sidepanel {
    width: 70px;
    min-width: 70px;
  }
  
  .contents {
    margin-left: 70px;
    width: calc(100% - 70px);
  }
  
  .component-wrapper {
    padding: 0.5rem;
    overflow-y: scroll !important;
    max-height: 100%;
    min-height: 0;
  }
}

/* Small tablets and large phones (768px and below) */
@media (max-width: 768px) {
  .sidepanel {
    width: 70px;
    min-width: 70px;
  }
  
  .contents {
    margin-left: 70px;
    width: calc(100% - 70px);
  }
  
  .component-wrapper {
    padding: 0.5rem;
    overflow-y: scroll !important;
    max-height: 100%;
    min-height: 0;
  }
}

/* Mobile phones (640px and below) */
@media (max-width: 640px) {
  .main {
    flex-direction: column;
  }
  
  .sidepanel {
    position: fixed;
    width: 70px;
    min-width: 70px;
    height: 100vh;
    transform: translateX(0);
    z-index: 1001;
    transition: transform 0.3s ease, width 0.3s ease;
  }
  
  .sidepanel.mobile-open {
    width: 250px;
    min-width: 250px;
    transform: translateX(0);
    box-shadow: 4px 0 20px rgba(0, 0, 0, 0.3);
  }
  
  .sidepanel.mobile-open .sidebar-container {
    width: 250px !important;
  }
  
  .sidepanel.mobile-open .item-text,
  .sidepanel.mobile-open .section-title,
  .sidepanel.mobile-open .section-toggle,
  .sidepanel.mobile-open .welcome-text {
    display: block !important;
  }
  
  .sidepanel.mobile-open .dashboardlist {
    justify-content: flex-start !important;
    padding: 0.6rem 0.8rem !important;
    border-left: 3px solid transparent !important;
  }
  
  .sidepanel.mobile-open .dashboardlist i {
    margin-right: 0.8rem !important;
  }
  
  .sidepanel.mobile-open .section-header {
    justify-content: space-between !important;
    padding: 0.6rem 0.8rem !important;
  }
  
  .sidepanel.mobile-open #welcome {
    flex-direction: row !important;
    text-align: left !important;
  }
  
  .sidepanel.mobile-open .logolayer {
    justify-content: space-between !important;
  }
  
  .sidepanel.mobile-open #logoicon {
    display: block !important;
  }
  
  
  .mobile-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    animation: fadeIn 0.3s ease;
  }
  
  .contents {
    margin-left: 70px;
    width: calc(100% - 70px);
    margin-top: 0;
    transition: margin-left 0.3s ease, width 0.3s ease;
  }
  
  .component-wrapper {
    padding: 0.5rem;
    margin-top: 0;
    overflow-y: scroll !important;
    max-height: 100%;
    min-height: 0;
  }
}

/* Small mobile phones (480px and below) */
@media (max-width: 480px) {
  .sidepanel {
    width: 60px;
    min-width: 60px;
  }
  
  .contents {
    margin-left: 60px;
    width: calc(100% - 60px);
  }
  
  .component-wrapper {
    padding: 0.25rem;
    overflow-y: scroll !important;
    max-height: 100%;
    min-height: 0;
  }
}

/* Extra small phones (360px and below) */
@media (max-width: 360px) {
  .sidepanel {
    width: 55px;
    min-width: 55px;
  }
  
  .contents {
    margin-left: 55px;
    width: calc(100% - 55px);
  }
  
  .component-wrapper {
    padding: 0.25rem;
    overflow-y: scroll !important;
    max-height: 100%;
    min-height: 0;
  }
}

/* Landscape orientation on mobile */
@media (max-height: 500px) and (orientation: landscape) {
  .sidepanel {
    width: 60px;
    min-width: 60px;
  }
  
  .contents {
    margin-left: 60px;
    width: calc(100% - 60px);
  }
  
  .component-wrapper {
    overflow-y: scroll !important;
    max-height: 100%;
    min-height: 0;
  }
}

/* Prevent horizontal scroll */
@media (max-width: 768px) {
  .main {
    overflow-x: hidden;
  }
  
  .component-wrapper {
    max-width: 100%;
    overflow-x: hidden;
    overflow-y: scroll !important;
    max-height: 100%;
    min-height: 0;
  }
}
</style>

